export function toggleBodyClass(key, value) {
  document.body.classList.toggle(key, value)
}

export function toggleOrderBookAnimation(showAnimation) {
  toggleBodyClass('disable-order-book-animation', !showAnimation)
}
